module.exports = __webpack_public_path__ + "img/notification-modal-bg.d4f5923a.png";